"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var main_1 = require("../../themes/main");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        more: {
            color: theme.palette.primary.dark,
            backgroundColor: main_1.materialColors.grey[200],
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "13px",
            textTransform: "none",
        },
    });
});
